
<script>

// 使用方式

// 传入 monthFee -> number ， 会生成 每月缴纳 ***元的提示字符
// 传入 tip -slot 会产生提示，popup 的slot会自动弹出这个内容
import { Cell, NavBar,Button,Row,Col,Field,CellGroup,Toast,Checkbox, CheckboxGroup,Icon, Popup, Picker} from 'vant';
import {SlotsMixin} from '../pages/util/slots';
import {n} from '../pages/util/common';
import _ from 'lodash';
import Vue from 'vue';
Vue.use(Popup);

export default {
  name: 'sby-field',
  mixins:[SlotsMixin],
  components: {
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Icon.name]: Icon,
    [Col.name]: Col,
    [Row.name]: Row
  },
  props: {
    icon: String,
    size: String,
    required: Boolean,
    title: [String, Number],
    value: [String, Number],
    label: [String, Number],
    border: {
      type: Boolean,
      default: true
    },
    error: Boolean,
    rightIcon: String,
    inputAlign: String,
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    unit: {
      type: String,
      default: '元'
    },
    monthFee: Number,

    // 自定义属性，查看个税费用明细
    detailTip: String,
    showDetailTip: {
      type: Boolean,
      default: true
    },

    hasPopup: {
      type: Boolean,
      default: true
    },
    
  },
  data: function() {
    return {
      popupshow: false
    }
  },
  computed: {
    
    listeners() {
      return {
        ...this.$listeners,
        input: this.onInput
      };
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event.target.value);
    },
    onDetailTipClick() {
      if (this.slots('popup')) {
        this.popupshow = true;
      }
    },
    renderInput() {
      const inputProps = {
        ref: 'input',
        class: [this.inputAlign, 'van-field__control van-field__control--right pay-field____control'],
        domProps: {
          value: this.value
        },
        attrs: {
          ...this.$attrs,
          readonly: this.readonly
        },
        on: this.listeners
      };

      if (this.type === 'textarea') {
        return <textarea {...inputProps} />;
      }

      return <input type={this.type} disabled={this.disabled} {...inputProps} />;
    },

  },
  render(h) {
    const { slots, labelAlign } = this;

    const mPupup = (slots('popup') &&
          <Popup position="bottom" getContainer="body" value={this.popupshow} onInput={(value)=> {
            this.popupshow = value;
          }}>
            {slots('popup')}
          </Popup>
        )
    const tips = (
           slots('tip') &&
          <div class="van-field__body margin-top-12 field-tips" onClick={this.onDetailTipClick}>
            <div class="pay-field__empty"></div>
            {slots('tip')}
          </div>
    )


    return (
      <van-cell class="pay-field"  title={this.label} border={this.border} 
        isLink={this.isLink}
        required={this.required}>
        <div class="van-field__body">
          <div class="pay-field__empty"></div>
          {this.renderInput()}
          <span class="margin-left-5 text-gray">{this.unit}</span>
        </div>
        {tips}
        {mPupup}
     </van-cell>
    )
  }
}
</script>

<style lang="less" scoped>

.pay-field {
  .pay-field__empty {
    flex: 1;
  }

.van-cell__value {
      min-width: 220px;
}

  .pay-field____control {
  }
  .van-field__body.field-tips {
      font-size:14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sby-pay-field.vue